import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Usuario } from '../../../../usuario/usuario';
import { MotivoPerdaVenda } from '../../../../motivo-perda-venda';

@Component({
    selector: 'sgt-cliente-congelamento-card-info',
    templateUrl: './cliente-congelamento-card-info.component.html',
    styleUrls: ['./cliente-congelamento-card-info.component.less']
})
export class ClienteCongelamentoCardInfoComponent implements OnInit, AfterViewInit {
    @Input() title = 'Dados do Congelamento';
    @Input() dataCongelamento: Date;
    @Input() usuarioCongelamento: Usuario;
    @Input() motivoCongelamento: MotivoPerdaVenda;
    @Input() justificativaCongelamento: string;

    @Input() isCollapseOpenedDefault = true;
    isCollapseOpened: boolean;

    @Output() afterOpen = new EventEmitter();
    @Output() afterClose = new EventEmitter();

    @ViewChild('collapse') collapse: ElementRef;

    ngOnInit() {
        this.isCollapseOpened = this.isCollapseOpenedDefault;
    }

    ngAfterViewInit() {
        if (!this.isCollapseOpenedDefault) {
            jQuery(this.collapse.nativeElement).css('display', 'none');
        }
    }


    /** Abre/Fecha o collapse */
    async toggleCollapse(): Promise<void> {
        return new Promise<any>(async (resolve) => {
            this.isCollapseOpened = !this.isCollapseOpened;
            if (this.isCollapseOpened) {
                return await this.open();
            }

            return await this.close();
        });
    }

    /** Abre o collapse */
    async open(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.isCollapseOpened = true;
            jQuery(this.collapse.nativeElement).slideDown(400, () => {
                this.afterOpen.emit();
                resolve();
            });
        });
    }

    /** Fecha o collapse */
    close(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.isCollapseOpened = false;
            jQuery(this.collapse.nativeElement).slideUp(400, () => {
                this.afterClose.emit();
                resolve();
            });
        });
    }
}
